import Button from './button';
import Checkbox from './checkbox';
import Input from './input';
import { modalTheme } from './modal';

export default { Button, Input, Checkbox, Modal: modalTheme };
